"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethods = exports.PaymentMethodNames = void 0;
exports.PaymentMethodNames = [
    "L/C payable at sight",
    "Cash on Delivery (COD) at CY",
    "Prepayment",
    "Cash on Delivery (COD) at Facility",
    "L/C usance",
    "Telegraphic transfer scanned (documents)",
    "From end of week of delivery",
    "Telegraphic transfer scanned (arrival)",
    "Cash on Loading (COL)",
    "CAD scanned",
    "CAD bank",
    "From invoice date",
];
exports.PaymentMethods = [
    {
        name: "L/C payable at sight",
        fullName: "Letter of credit payable at sight",
        trigger: "L/C presentment",
        triggerTime: "after",
    },
    {
        name: "Cash on Delivery (COD) at CY",
        fullName: "Cash on delivery at container terminal",
        trigger: "Arrival",
        triggerTime: "after",
    },
    {
        name: "Prepayment",
        fullName: "Prepayment",
        trigger: "Contract date",
        triggerTime: "after",
    },
    {
        name: "Cash on Delivery (COD) at Facility",
        fullName: "Cash on Delivery (COD) at Facility",
        trigger: "Delivery",
        triggerTime: "after",
    },
    {
        name: "L/C usance",
        fullName: "Letter of credit usance",
        trigger: "Days deferred payment",
        triggerTime: "after",
    },
    {
        name: "Telegraphic transfer scanned (documents)",
        fullName: "Telegraphic transfer against scanned documents",
        trigger: "Scanned documents receipt",
        triggerTime: "after",
    },
    {
        name: "From end of week of delivery",
        fullName: "From end of week of delivery",
        trigger: "From end of week of delivery",
        triggerTime: "after",
    },
    {
        name: "Telegraphic transfer scanned (arrival)",
        fullName: "Telegraphic transfer scanned prior to arrival at disport",
        trigger: "To arrival at disport",
        triggerTime: "prior",
    },
    {
        name: "Cash on Loading (COL)",
        fullName: "Cash on loading",
        trigger: "Loading",
        triggerTime: "after",
    },
    {
        name: "CAD scanned",
        fullName: "Cash against scanned documents",
        trigger: "Scanned documents receipt",
        triggerTime: "after",
    },
    {
        name: "CAD bank",
        fullName: "Cash against documents at bank",
        trigger: "Original documents receipt at Buyer's bank",
        triggerTime: "after",
    },
    {
        name: "From invoice date",
        fullName: "From invoice date",
        trigger: "From invoice date",
        triggerTime: "after",
    },
];
